/*-------------------------------------------------
	FIRST-VIEW
-------------------------------------------------*/
$(document).ready(function () {
   	hsize = $(window).height();
   	$('.sp-top-slide').css('height', hsize + 'px');
	});
	$(window).resize(function () {
   	hsize = $(window).height();
  	$('.sp-top-slide').css('height', hsize + 'px');
});

/*-------------------------------------------------
	HEADER-CHENGE
-------------------------------------------------*/
$(function() {
	
	var moveHead = '.shopify-section--collection-list';
	var scrollY = 500;
	
	if($('.shopify-section--collection-list').is(moveHead)){

		$(window).scroll(function() {
			if ($(window).scrollTop() > scrollY) {
              $('.lang-switch-sp').fadeOut('fast');
              $('#header').addClass('scrolled');
              $('.mobile_logo').fadeIn();
              $('.button_container').addClass('color-change');
              $('.wrap--sp-cart').addClass('color-change');
			} else {
              $('.lang-switch-sp').fadeIn('fast');
              $('#header').removeClass('scrolled');
              $('.mobile_logo').fadeOut();
              $('.button_container').removeClass('color-change');
              $('.wrap--sp-cart').removeClass('color-change');
			};
		});
	} else {
	};
});

/*-------------------------------------------------
	SP-MENU
-------------------------------------------------*/
$(function(){
	$('#toggle').click(function(){
		$(this).toggleClass('active');
		$('#overlay').toggleClass('openOL');
      $('body').toggleClass('sp-menu-bg-fix');
	});
	
	$('li.g-nav_menu a').click(function(){
		$('#toggle').removeClass('active');
      $('body').removeClass('sp-menu-bg-fix');
	});
});
